import { createContext } from 'react';

interface PathRecord {
  idx: number;
  pathname: string;
}

interface NavigationContextProps {
  records: Record<string, PathRecord[]>;
  history: PathRecord[];
  // eslint-disable-next-line no-unused-vars
  setHistoryPointer: (value: string) => void;
}

export default createContext<NavigationContextProps>({
  history: [],
  setHistoryPointer: () => {},
  records: {},
});
